import React from 'react';

interface SvgNamespaceTagProps {
    prefix: string;
    color?: string;  // Hex color or undefined (default violet)
    x?: number;      // X position (right edge alignment)
    y?: number;      // Y position
}

/**
 * SVG version of NamespaceTag for use within SVG diagrams.
 * Matches the styling of the HTML NamespaceTag component.
 */
export const SvgNamespaceTag: React.FC<SvgNamespaceTagProps> = ({ prefix, color, x = 0, y = 0 }) => {
    // Default to violet if no color specified (matches NamespaceTag: rgb(139, 92, 246))
    const bgColor = color || '#8b5cf6';
    const textColor = '#fff';

    // Calculate badge width based on prefix length (minimum 26px)
    const badgeWidth = Math.max(26, prefix.length * 6 + 10);
    const badgeHeight = 12;

    return (
        <g className="namespace-tag" transform={`translate(${x - badgeWidth}, ${y})`}>
            <rect
                width={badgeWidth}
                height={badgeHeight}
                rx={3}
                fill={bgColor}
                opacity={0.9}
            />
            <text
                x={badgeWidth / 2}
                y={9}
                textAnchor="middle"
                style={{
                    fontSize: '8px',
                    fill: textColor,
                    fontFamily: 'Arial',
                    fontWeight: 'bold',
                    pointerEvents: 'none',
                    textTransform: 'uppercase'
                }}
            >
                {prefix}
            </text>
        </g>
    );
};
